import { render, staticRenderFns } from "./Confirm2.vue?vue&type=template&id=fb577f00&"
import script from "./Confirm2.vue?vue&type=script&lang=js&"
export * from "./Confirm2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports